/**
 * Calculate new cursor position after formatting transformation.
 * Uses digit-counting algorithm: counts digits before cursor in old value,
 * then finds position with same digit count in new value.
 *
 * @param oldValue - Value before formatting
 * @param newValue - Value after formatting
 * @param oldCursor - Cursor position before formatting
 * @param significantChars - Regex for significant characters (default: digits and +)
 * @returns New cursor position
 */
export function calculateNewCursorPosition(
  oldValue: string,
  newValue: string,
  oldCursor: number,
  significantChars = /[\d+]/,
): number {
  // Count significant characters before cursor in old value
  const charsBefore = oldValue
    .slice(0, oldCursor)
    .split('')
    .filter((c) => significantChars.test(c)).length;

  // Find position in new value with same count of significant characters
  let newCursor = 0;
  let count = 0;
  for (let i = 0; i < newValue.length && count < charsBefore; i++) {
    if (significantChars.test(newValue[i])) {
      count++;
    }
    newCursor = i + 1;
  }

  return newCursor;
}
